import { Injectable, signal } from '@angular/core';
import { UpdateAction } from '@app/services/session/update-action';
import { defined } from '@app/fremework/functions';

@Injectable({
  providedIn: 'root',
})
export class SessionService{

  private map: Map<string, string> = new Map<string, string>();

  constructor() {
    Object.keys(sessionStorage).map(key => {
      this.set(key, sessionStorage.getItem(key));
    })
  }

  private updateAction = signal<UpdateAction>(undefined);

  get SessionUpdates() : UpdateAction {
    return this.updateAction();
  }

  public get(key: string, consume?: boolean): string {
    const item = window.sessionStorage.getItem(key);
    if (item && consume) {
      window.sessionStorage.removeItem(key);
      this.map.delete(key);
      this.updateAction.update(() => ({action: 'delete', item: {key, value: undefined}}));
    }
    return item;
  }

  public set(key: string, value: string): void {
    if(!defined(key)) {
      return;
    }
    window.sessionStorage.setItem(key, value);
    this.map.set(key, value);
    this.updateAction.update(() => ({action: 'set', item: {key,value}}));
  }

  public remove(key: string): void {
    window.sessionStorage.removeItem(key);
    this.map.delete(key);
    this.updateAction.update(() => ({action: 'delete', item: {key,value: undefined}}));
  }

  public clear(): void {
    Object.keys(sessionStorage).map(key => {
      this.updateAction.update(() => ({action: 'delete', item: {key,value: undefined}}));
    })
    this.map.clear();
    window.sessionStorage.clear();
  }

  public hasKey(key: string): boolean {
    return !!window.sessionStorage.getItem(key);
  }
}
